<script setup lang="ts">
import type { DashboardInventoryHealthMetric } from "../../features/dashboard/dashboard.types.ts";

defineProps<{
  beforeMetrics: DashboardInventoryHealthMetric[];
  afterMetrics: DashboardInventoryHealthMetric[];
  totalLocations: number;
  summary: string;
}>();
</script>

<template>
  <section class="dashboard-card rounded-[1.5rem] px-5 py-5">
    <div class="flex items-center justify-between gap-3">
      <h2 class="dashboard-text-primary text-lg font-semibold">
        Inventory Health Impact
      </h2>
      <span class="dashboard-text-muted text-xs"
        >Before and after redistribution</span
      >
    </div>

    <div class="mt-6 grid gap-4 md:grid-cols-[1fr_auto_1fr]">
      <div class="dashboard-card--inner rounded-2xl px-4 py-4">
        <p
          class="dashboard-text-muted text-xs font-semibold tracking-[0.16em] uppercase"
        >
          Before Redistribution
        </p>
        <div class="mt-4 grid gap-3">
          <div
            v-for="metric in beforeMetrics"
            :key="metric.label"
            class="dashboard-card--inner flex items-center justify-between gap-4 rounded-xl px-3 py-3"
          >
            <span
              class="dashboard-text-primary flex items-center gap-3 text-sm"
            >
              <span class="dashboard-pill" :class="metric.colorClass"></span>
              {{ metric.label }}
            </span>
            <span class="dashboard-text-primary text-xl font-semibold">{{
              metric.value
            }}</span>
          </div>
        </div>
      </div>

      <div class="hidden items-center justify-center md:flex">
        <span class="dashboard-text-link text-4xl">›</span>
      </div>

      <div class="dashboard-card--inner rounded-2xl px-4 py-4">
        <p
          class="dashboard-text-muted text-xs font-semibold tracking-[0.16em] uppercase"
        >
          After Redistribution
        </p>
        <div class="mt-4 grid gap-3">
          <div
            v-for="metric in afterMetrics"
            :key="metric.label"
            class="dashboard-card--inner flex items-center justify-between gap-4 rounded-xl px-3 py-3"
          >
            <span
              class="dashboard-text-primary flex items-center gap-3 text-sm"
            >
              <span class="dashboard-pill" :class="metric.colorClass"></span>
              {{ metric.label }}
            </span>
            <span class="dashboard-text-primary text-xl font-semibold">{{
              metric.value
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="dashboard-divider dashboard-text-secondary mt-5 flex flex-col gap-3 border-t pt-4 text-sm md:flex-row md:items-center md:justify-between"
    >
      <span
        >Total Locations
        <strong class="dashboard-text-primary">{{
          totalLocations
        }}</strong></span
      >
      <span class="dashboard-text-positive font-medium">{{ summary }}</span>
    </div>
  </section>
</template>
